<template>
    <v-form ref="form" class="form-container" lazy-validation>
        <v-textarea
            v-if="getCurrentSMSCampaign"
            v-model="textTemplate"
            class="form-field"
            :label="`SMS text template, You can use up to ${getCurrentSMSCampaign.params} placeholder(s)`"
            hint="Click on the buttons below to insert a placeholder to your SMS text, each placeholder represents column 2 and above. Column 1 is reserved for your recipient(s) list."
            :rules="[
                v => !!v || 'Field Required'
            ]"
            required
        />
        <div v-if="getCurrentSMSCampaign" class="params-container">
            <div v-for="param in getCurrentSMSCampaign.params" :key="param">
                <v-btn color="cyan" dark @click="addParamInText(param)">
                    Param {{ param }}
                </v-btn>
            </div>
        </div>
        <create-form-actions
            has-previous-step-btn
            :are-buttons-disabled="submitLoading"
            @reset="reset"
            @cancel="cancel"
            @next-step="emitNextStep"
            @previous-step="emitPrevStep"
        />
    </v-form>
</template>

<script>
    import smsCampaignService from '@/services/sms-campaign-service'
    import CreateFormActions from '@/components/CreateFormActions.vue'
    import EventBus from '@/event-bus'
    export default {
        components: { CreateFormActions },
        data() {
            return {
                textTemplate: '',
                submitLoading: false
            }
        },
        computed: {
            getCurrentSMSCampaign() {
                return this.$store.getters.getCurrentSMSCampaign
            },
            getCurrentExcludedSMSCampaignIds() {
                return this.$store.getters.getCurrentExcludedSMSCampaignIds
            }
        },
        created() {
            EventBus.$on('reset-new-campaign-form', () => {
                this.textTemplate = ''
                this.submitLoading = false
            })
        },
        methods: {
            addParamInText(param) {
                this.textTemplate += ` {PARAM${param}} `
            },
            emitNextStep() {
                if (!this.$refs.form.validate()) { return }
                const campaign = {
                    ...this.getCurrentSMSCampaign,
                    textTemplate: this.textTemplate
                }
                this.$store.dispatch('setCurrentSMSCampaign', campaign)
                this.submitLoading = true
                smsCampaignService
                    .createSMSCampaign(this.getCurrentSMSCampaign)
                    .then((resp) => {
                        this.storeSMS({
                            ...campaign,
                            ...resp.data
                        })
                    })
                    .catch((error) => {
                        this.$emit('set-alert', error.response.data.message, 'error')
                    })
            },
            emitPrevStep() {
                this.$emit('prev-step')
            },
            reset() {
                this.$emit('reset')
            },
            cancel() {
                this.$emit('cancel')
            },
            storeSMS(campaignAfterCreate) {
                if (this.getCurrentSMSCampaign.file) {
                    const formData = new FormData()
                    formData.append('file', this.getCurrentSMSCampaign.file)
                    formData.append('excludedCampaignIds', this.getCurrentExcludedSMSCampaignIds)
                    return smsCampaignService
                        .uploadSMSCampaignFile(campaignAfterCreate.id, formData)
                        .then(() => {
                            this.submitLoading = false
                            this.$store.dispatch('setCurrentSMSCampaign', campaignAfterCreate)
                            this.$emit('next-step')
                        })
                        .catch((error) => {
                            this.submitLoading = false
                            this.$emit('set-alert', error.response.data.message, 'error')
                        })
                }
                this.submitLoading = false
                this.$store.dispatch('setCurrentSMSCampaign', campaignAfterCreate)
                this.$emit('next-step')
            }
        }
    }
</script>

<style scoped>
.params-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 15px;
    margin-bottom: 20px;
}

.form-container {
    margin-bottom: 10px;
}

.form-field {
    width: 100%;
    margin-bottom: 30px;
    padding-left: 15px !important;
    padding-right: 15px !important;
}
</style>
